<template>
  <div
    id="ConexaoFinanceiraOfferCardContainer"
    v-when-visible="triggerEventWhenElementIsVisible"
    class="ConexaoFinanceiraOfferCardContainer"
  >
    <AffiliateOfferCardB
      v-if="abTest() === 'B'"
      :interest-rate="0.99"
      :max-duration="360"
      :max-amount="5000000"
      partner="CONEXAO_FINANCEIRA"
      product-label="Imóvel em garantia"
      @action-forward-click="selectOffer"
      @brand-click="selectOffer"
      @offer-conditions-click="selectOffer"
    />
    <AffiliateOfferCard
      v-else
      :interest-rate="0.99"
      :max-duration="360"
      :max-amount="5000000"
      partner="CONEXAO_FINANCEIRA"
      @action-forward-click="selectOffer"
      @brand-click="selectOffer"
      @offer-conditions-click="selectOffer"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import whenVisibleDirective from '@/aasgard/directives/when-visible'
import { PartnersFaq } from '~/helpers/partners/partnersFaq'
import { Partner } from '@/data/common'
import AffiliateOfferCard from '~/aasgard/components/cards/AffiliateOfferCard.vue'
import AffiliateOfferCardB from '~/aasgard/components/cards/AffiliateOfferCardB.vue'
import { abTest } from '~/helpers/abTest'
export default {
  name: 'ConexaoFinanceiraOfferCardContainer',
  components: {
    AffiliateOfferCardB,
    AffiliateOfferCard,
  },
  directives: {
    ...whenVisibleDirective,
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      busy: false,
      displayFaqsModal: false,
      offer: {
        partner: Partner.CONEXAO_FINANCEIRA,
      },
    }
  },
  computed: {
    ...mapGetters({
      gtHomeEquityLatestColdOfferRequest:
        'products/loans/home-equity/cold-offer/gtHomeEquityLatestColdOfferRequest',
      gtHomeEquityExtraQuestions:
        'products/loans/home-equity/cold-offer/gtHomeEquityExtraQuestions',
      gtUser: 'user/user/gtUser',
    }),
    cptdFaq() {
      return PartnersFaq[this.offer?.partner] ?? []
    },
  },
  mounted() {
    this.actInsertIntent({
      identifier: 'PARTNER_CONEXAO_FINANCEIRA_VIEW',
    })
  },
  methods: {
    abTest,
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actInsertIntent: 'user/intent/actInsertIntent',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    triggerEventWhenElementIsVisible() {
      this.actEmitGaEvent({
        eventLabel: 'card-conexao-financeira',
        eventCategory: 'card-conexao-financeira',
        eventAction: 'result-page-visualization',
      })
    },
    async selectOffer() {
      this.busy = true
      this.actEmitGaEvent({
        eventLabel: 'card-conexao-financeira',
        eventCategory: 'card-conexao-financeira',
        eventAction: 'result-page-click',
      })

      this.actSetLastLoanInteraction('home-equity')

      this.$router.push({
        path: `/contratacao/home-equity/afiliados/${Partner.CONEXAO_FINANCEIRA.toLowerCase()}/redirecionamento`,
      })

      this.busy = false
    },
  },
}
</script>
<style lang="scss"></style>
